<template>
	<div class="new-comment-view w-full bg-gray-200 rounded-md p-4">
		<div class="col-span-2">
			<div class="overflow-auto bg-gray-400">
				<pre v-if="selectedSnippet">{{ selectedSnippet }}</pre>
			</div>
		</div>
		<label>
			<span class="block">Type</span>
			<select aria-label="Label" v-model="type">
				<option value="praise" selected>Praise</option>
				<option value="nitpick">Nitpick</option>
				<option value="suggestion">Suggestion</option>
				<option value="issue">Issue</option>
				<option value="question">Question</option>
				<option value="thought">Thought</option>
				<option value="chore">Chore</option>
			</select>
		</label>
		<label>
			<span class="block">Decorations</span>
			<input type="text" placeholder="e.g. if-minor, non-blocking" class="w-full" v-model="decorations" />
		</label>
		<label class="col-span-2">
			<span class="block">Subject</span>
			<input placeholder="" class="block w-full" v-model="subject" />
		</label>
		<label class="col-span-2">
			<span class="block">Discussion</span>
			<textarea placeholder="" class="block w-full" v-model="discussion" />
		</label>
		<div class="col-span-2 flex items-center justify-between mt-1">
			<a href="https://conventionalcomments.org/" target="_blank" rel="noopener">Conventional Comments</a>
			<button class="px-4" @click="createComment">Submit</button>
		</div>
	</div>
</template>

<script>
import * as marked from 'marked';
import * as DOMPurify from 'dompurify';
import { v4 as uuidv4 } from 'uuid';
import { mapState } from 'vuex';

export default {
	props: ['selectedSnippet'],
	data() {
		return {
			type: 'praise',
			decorations: '',
			subject: '',
			discussion: '',
		};
	},
	computed: {
		...mapState(['username', 'linesSelected', 'linesSelectedMetadata']),
	},
	methods: {
		createComment() {
			this.$store.commit('addComment', {
				id: uuidv4(),
				snippet: this.linesSelected.length ? { ...this.linesSelectedMetadata, linesSelected: this.linesSelected } : null,
				type: this.type,
				decorations: this.decorations,
				subject: DOMPurify.sanitize(marked(this.subject)),
				discussion: DOMPurify.sanitize(marked(this.discussion)),
				replies: [],
				createdBy: this.username || null,
				createdAt: new Date().toISOString(),
			});

			// reset
			this.type = 'praise';
			this.decorations = '';
			this.subject = '';
			this.discussion = '';

			this.$store.commit('setLinesSelected', { selected: [], metadata: {} });
		},
	},
};
</script>

<style lang="postcss">
.new-comment-view {
	display: grid;
	grid-template-columns: auto minmax(0, 1fr);
	grid-gap: 8px;
}
</style>
